module.exports = __webpack_public_path__ + "static/media/points8_4.fb36de60.png";